import { GateShell } from "@/components/app/gate";
import { Hint } from "@/components/app/layout";
import { Button } from "@/components/ui/button";
import { useT } from "../i18n";

/**
 * The page nobody registered: the router's `defaultNotFoundComponent`
 * (board redesign, round 10). It used to be the router's own two words on
 * a light ground. The same door as every other refusal, with the one way
 * out. Core strings only: this is the main chunk.
 */
export function NotFoundPage() {
  const t = useT();
  return (
    <GateShell eyebrow={t("gate.wrongEyebrow")}>
      <p className="font-semibold text-pretty">{t("page.notFound")}</p>
      <Hint>{t("tournament.notFoundHint")}</Hint>
      <Button variant="outline" className="w-full" render={<a href="/" />}>
        {t("tournament.openList")}
      </Button>
    </GateShell>
  );
}
